'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SHARE_SERVICES = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _planEnquiryAnalyticsService = require('../../user/account/plan/planEnquiryAnalyticsService');

require('./ShareButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Analytics
var SHARE_SERVICES = exports.SHARE_SERVICES = {
    FACEBOOK: 'FACEBOOK',
    TWITTER: 'TWITTER',
    EMAIL: 'EMAIL'
};

var MESSAGE = {
    FACEBOOK: 'Share',
    TWITTER: 'Tweet',
    EMAIL: 'Email'
};

var getLink = function getLink(_ref) {
    var service = _ref.service,
        defaultContent = _ref.defaultContent,
        bodyContent = _ref.bodyContent,
        url = _ref.url;

    switch (service) {
        case SHARE_SERVICES.FACEBOOK:
            return 'https://www.facebook.com/sharer/sharer.php?u=' + url + '&description=' + defaultContent;
        case SHARE_SERVICES.TWITTER:
            return 'https://twitter.com/intent/tweet?text=' + defaultContent + '&url=' + url;
        case SHARE_SERVICES.EMAIL:
        default:
            return 'mailto:?subject=' + defaultContent + '&body=' + bodyContent;
    }
};

var getLinkTarget = function getLinkTarget(service) {
    switch (service) {
        case SHARE_SERVICES.FACEBOOK:
        case SHARE_SERVICES.TWITTER:
            return '_blank';
        case SHARE_SERVICES.EMAIL:
        default:
            return '_self';
    }
};

var getLinkAnalyticsEvent = function getLinkAnalyticsEvent(service) {
    switch (service) {
        case SHARE_SERVICES.FACEBOOK:
            return _planEnquiryAnalyticsService.googleAnalyticsFacebookReferralEvent;
        case SHARE_SERVICES.TWITTER:
            return _planEnquiryAnalyticsService.googleAnalyticsTwitterReferralEvent;
        case SHARE_SERVICES.EMAIL:
        default:
            return _planEnquiryAnalyticsService.googleAnalyticsEmailReferralEvent;
    }
};

var ShareButton = function ShareButton(_ref2) {
    var service = _ref2.service,
        defaultContent = _ref2.defaultContent,
        bodyContent = _ref2.bodyContent,
        url = _ref2.url,
        children = _ref2.children;
    return _react2.default.createElement(
        'a',
        { className: (0, _classnames2.default)('ShareButton', service.toLowerCase()),
            onClick: getLinkAnalyticsEvent(service),
            href: getLink({ service: service, defaultContent: defaultContent, bodyContent: bodyContent, url: url }),
            target: getLinkTarget(service) },
        children || MESSAGE[service]
    );
};

ShareButton.propTypes = {
    service: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string,
    defaultContent: _propTypes2.default.string.isRequired,
    bodyContent: _propTypes2.default.string,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node, _propTypes2.default.string])
};

exports.default = ShareButton;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/buttons/ShareButton.js
// module id = 1702
// module chunks = 0